import { render, staticRenderFns } from "./StoryFooter.vue?vue&type=template&id=003e81e2&scoped=true&"
import script from "./StoryFooter.vue?vue&type=script&lang=js&"
export * from "./StoryFooter.vue?vue&type=script&lang=js&"
import style0 from "./StoryFooter.vue?vue&type=style&index=0&id=003e81e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003e81e2",
  null
  
)

export default component.exports